module.exports = __webpack_public_path__ + "img/environmentalBG.eece401a.jpg";